import { CommonModule } from '@angular/common';
import { Component, Input, forwardRef } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { ShowErrorComponent } from '../show-error/show-error.component';

@Component({
  selector: 'app-input-date',
  templateUrl: './input-date.component.html',
  imports: [CommonModule, ShowErrorComponent, FormsModule, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDateComponent),
      multi: true,
    },
  ],
})
export class InputDateComponent {
  @Input() label!: string;
  @Input() placeholder = 'dd/mm/yyyy';
  @Input() control!: FormControl | AbstractControl | null;
  @Input() showError = true;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  get formControl(): FormControl {
    return this.control as FormControl;
  }

  get normalizedFieldName(): string {
    if (!this.label) return '';
    if (this.label === this.label.toUpperCase()) {
      return this.label;
    }
    return this.label.charAt(0).toLowerCase() + this.label.slice(1);
  }

  get isRequired(): boolean {
    if (!this.control) return false;
    const validator = this.control.validator
      ? this.control.validator({} as any)
      : null;
    return validator ? validator['required'] === true : false;
  }

  writeValue(value: any): void {
    if (value) {
      const normalized = this.normalize(value);
      this.formControl.setValue(normalized, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

  onInput(event: Event): void {
    let input = (event.target as HTMLInputElement).value;
    input = this.normalize(input);
    this.formControl.setValue(input, { emitEvent: true });
    this.formControl.markAsTouched();
    this.onChange(input);
    this.onTouched();
  }

  private normalize(value: string): string {
    value = value.replace(/[^0-9]/g, '');
    if (value.length >= 3 && value[2] !== '/') {
      value = value.slice(0, 2) + '/' + value.slice(2);
    }
    if (value.length >= 6 && value[5] !== '/') {
      value = value.slice(0, 5) + '/' + value.slice(5);
    }
    return value.slice(0, 10);
  }
}
